import React, { useEffect, useState } from "react";
import WhyChooseUsCard from "./WhyChooseUsCard";
import Data from "../why-choose-us/WhyChooseUsCardData.json";
import SectionTitle from "../section-title/SectionTitle";
import axios from "axios";

const WhyChooseUs = () => {
  const [homeWeAre, setHomeWeAre] = useState(null);
  // console.log("about", homeWeAre);
  const fetchHomeWeare = async () => {
    try {
      const response = await axios.get(
        "https://portal.ebs365.info/api/sites/3/pages/home"
      );
      setHomeWeAre(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchHomeWeare();
  }, []);

  //   console.log("Fetched Data:", homeWeAre);
  let heroSection = null;
  if (homeWeAre && homeWeAre.data && homeWeAre.data.sections) {
    heroSection = homeWeAre.data.sections.find(
      (section) => section.title === "Why_Choose_Us"
    );
  }


  return (
    <>
      {/* Why Choose Us Start */}
      <div
        className="why-choose why-choos-bg"
        style={{ backgroundImage: `url(/images/why-choose-bg.jpg)` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6" />
            <div className="col-md-6 why-choose-us-before">
              <div className="row">
              {heroSection && heroSection.items
                  ? heroSection &&
                    heroSection.items.map(
                      (data, i) =>
                        data.title.includes("Why_Choose_Us_item") && (
                          <div key={i}>
                             <SectionTitle title="<span>Why</span> Choose Us" />
                          </div>
                        )
                    )
                  : null}
               

                {heroSection && heroSection.items
                  ? heroSection &&
                    heroSection.items.map(
                      (data, i) =>
                        data.title.includes("why_choose_us_item_") && (
                          <div key={i} className="col-md-6 col-sm-6">
                            <WhyChooseUsCard key={data.id} data={data}  />
                          </div>
                        )
                    )
                  : null}
                
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Why Choose Us End */}
    </>
  );
};

export default WhyChooseUs;
